/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: TerritoriesAddComponent
 * Purpose		: This component allows to create new Territories record and save changes.
 * Dependency	: TerritoriesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit,
	HostBinding, trigger, transition, animate,
	style, state } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';

import { TerritoriesData, TerritoriesService } from './Territories.service';
import { RegionData, RegionService } from '../Region/Region.service';


@Component({
	selector: 'my-Territories-add',
	template: require('./TerritoriesAdd.component.html'),
	providers: [TerritoriesService
		, RegionService
		],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class TerritoriesAddComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }

	objTerritories: TerritoriesData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	
	RegionList: RegionData[];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
	private toastr: ToastsManager,
    private TerritoriesService: TerritoriesService
			, private  RegionService:  RegionService

	) {
		this.objTerritories = new TerritoriesData();
	}

	ngOnInit() {
		this.objTerritories = new TerritoriesData();
		this.getLookups();
	}

	addTerritories() {
		this.TerritoriesService.addTerritoriesData(this.objTerritories)
			.subscribe(record => this.router.navigate(['/Territories']),
			error =>  this.errorMessage = 'There was an error while adding record. Error: ' + <any>error,
			() => { 
				this.toastr.success('Territories record added successfully...', 'Add Territories');
				console.log('Territories record added successfully...'); 
			}
		);
	}

	gotoTerritories() {
		// let Id = this.objTerritories ? this.objTerritories.TerritoryID : null;
		this.router.navigate(['/Territories']);
	}

	// Get Lookup List for Region
    getRegion() {
		this.RegionService.getAll().subscribe(records => this.RegionList=records);
    }

	getLookups() {

        this.getRegion();
	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Territories/TerritoriesAdd.component.ts